import React, { useState } from 'react';
import UQIcon from '../icon';
import UQLoader, { UQLoaderProps } from '../loader';
import './style.scss';

export interface UQCardProps {
  header?: string; 
  icon?: string; 
  iconColor?: string; 
  collapsable?: boolean; 
  loading?: boolean; 
  className?: string; 
  children?: React.ReactNode; 
  loaderProps?: UQLoaderProps; // <-- Add this line
}

const Card = (props: UQCardProps) => {
  const [collapsed, setCollapsed] = useState<Boolean>(true);

  const onHeaderClick = () => {
    setCollapsed(!collapsed);
  };


  return (
    <>
      {(props.header) ? (
        <div className={"card " + props.className}>
          <div className="card-header" onClick={onHeaderClick}>
            {props.icon ? (
              <div className={'card-icon ' + props.iconColor}>
                <UQIcon icon={props.icon!}></UQIcon>
              </div>
            ) : (null)}
            <h2 className="card-title">
              {props.header}
              {!props.collapsable ? (null) : (
                <UQIcon icon={"chevron-"+(collapsed ? "up" : "down")}></UQIcon>
              )}
            </h2>
          </div>
          {collapsed && props.collapsable ? (null) : (
            <>
              {props.loading ? (
                <div className='card-loader'>
                  <UQLoader {...props.loaderProps}></UQLoader>
                </div>
              ) : (
                <div className={"card-body " + (props.loading ? 'hidden' : '')}>
                  {props.children}
                </div>
              )}
            </>
          )}
          

        </div>
      ) : (
        <div className={"card " + props.className}>
          {props.loading ? (
            <div className='card-loader'>
              <UQLoader {...props.loaderProps}></UQLoader>
            </div>
          ) : (
            <>{props.children}</>
          )}
        </div>
      )}
    </>
  );
};

export default Card;

